<template>
  <div class="activity-log-list" v-loading="isLoading">
    <div class="activity-log-list__header">
      <div class="title">{{L10n('activity-log')}}</div>
      <div v-if="list.length" class="activity-log-list__btn-wrap-all">
        <button
          type="button"
          class="btn btn-size-s btn-no-border"
          @click="handlerShowViewAll"
        >
          {{L10n('view-all')}}
        </button>
      </div>
      <div>
        <button
          type="button"
          class="btn btn-size-s btn-no-border"
          @click="handleOpenCreateItem"
        >
          <i class="el-icon-plus"></i>
          {{L10n('add')}}
        </button>
      </div>
    </div>
    <div class="activity-log-list__content">
      <no-data-layout :isNoData="isNoData">
        <activity-item
          v-for="item in previewItemList"
          :key="item.id"
          :data="item"
          :formModel="Model"
        >
          <div class="activity-log-list__btn-view-more-wrap">
            <ui-button
              class="btn btn-size-xs btn-white btn-view-more"
              @click="handlerShowViewAll"
            >
              {{L10n('view-more')}}
            </ui-button>
          </div>
        </activity-item>
      </no-data-layout>
    </div>
    <div class="activity-log-list__footer">
      <!-- SLOT -->
      <slot name="dialog-info"></slot>
    </div>
    <modal-new
      v-if="isVisibleDialog"
      :isLoading="isLoading"
      @onCreate="handlerCreateItem"
      @onClose="handleCloseCreateItem"
    ></modal-new>
    <dialog-info
      v-if="isVisibleModalAll"
      :isLoading="isLoading"
      :title="L10n('activity-log-list')"
      customClass="activity-log-dialog"
      ref="modalAll"
      @close="handlerHideViewAll"
    >
      <activity-item
        v-for="item in list"
        :key="item.id"
        :data="item"
        :formModel="Model"
      ></activity-item>
      <!-- SLOT -->
      <slot name="dialog-info"></slot>
    </dialog-info>
  </div>
</template>

<script>
import { waitValue } from '@/utils/promises'

export default {
  name: 'ActivityInfoLog',
  components: {
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ './Item'),
    'modal-new': () => import(/* webpackChunkName: 'Shared' */ './ModalNew'),
    'no-data-layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/NoData'),
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo')
  },
  props: {
    maxPreviewCount: {
      type: Number,
      default: 1
    },
    isLoading: {
      type: Boolean
    },
    Model: {
      type: Function,
      required: true
    },
    list: {
      type: Array
    }
  },
  data () {
    return {
      isVisibleDialog: false,
      isVisibleModalAll: false
    }
  },
  computed: {
    isNoData () {
      return this.list.length === 0
    },
    previewItemList () {
      return this.list.slice(0, this.maxPreviewCount)
    }
  },
  methods: {
    /* AND USER INTERFACE */
    handlerShowViewAll () {
      this.isVisibleModalAll = true
      waitValue(() => this.$refs['modalAll'])
        .then((dialog) => {
          this.$emit('onViewAll')
          dialog.show()
        })
    },
    handlerHideViewAll () {
      this.$nextTick(() => {
        this.isVisibleModalAll = false
      })
    },
    handlerCreateItem (data) {
      this.$emit('onCreate', data)
      this.isVisibleDialog = false
    },
    handleOpenCreateItem () {
      this.isVisibleDialog = true
    },
    handleCloseCreateItem () {
      this.isVisibleDialog = false
    }
  }
}
</script>
<style lang="stylus">
.dialog-scroll .el-dialog.activity-log-dialog{
  max-width 70rem
}
.activity-log-list{
  display flex
  flex-direction column
  .title{
    color grey
    font-weight 500
  }
  .title::first-letter{
    text-transform capitalize
  }
  .sub-title{
    color grey
    font-size .8em
  }
  &__header{
    display flex
    align-items center
    justify-content space-between
  }
  &__btn-wrap-all{
    margin-left auto
    margin-right 1rem
  }
  &__content{
    min-height 5rem
  }
  &__btn-view-more-wrap{
    position relative
    display flex
    align-items center
    justify-content center
    .btn-view-more{
      position absolute;
      z-index 2
      top -3.9rem
    }
  }
}
</style>
